module.exports = __webpack_public_path__ + "img/maham.5b471d9d.png";